import { render, staticRenderFns } from "./ApPaga.vue?vue&type=template&id=44570e58&scoped=true"
import script from "./ApPaga.vue?vue&type=script&lang=js"
export * from "./ApPaga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44570e58",
  null
  
)

export default component.exports